import styled from 'styled-components';

export const LinesContainer = styled.div`
  width: 100%;
  display: flex;
`;

export const FixedPart = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MovablePart = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
`;
